import { useState } from "react";
import imgNotification from "../assets/img/election-notification.jpg";
import imgResults from "../assets/img/election-results.jpg";

const DOCS = [
  { key: "notification", label: "Notification",    icon: "📋", img: imgNotification, alt: "TMP Intra-Party Election Notification – 19 Jan 2026" },
  { key: "results",      label: "Election Results", icon: "✅", img: imgResults,      alt: "TMP Intra-Party Election Results – 19 Jan 2026" },
];

export default function ElectionResultsModal({ show, onClose }) {
  const [tab, setTab] = useState("notification");
  const [zoom, setZoom] = useState(false);

  if (!show) return null;

  const active = DOCS.find(d => d.key === tab);

  return (
    <>
      {/* Backdrop */}
      <div className="er-backdrop" onClick={zoom ? () => setZoom(false) : onClose} />

      {/* Zoom lightbox */}
      {zoom && (
        <div className="er-lightbox" onClick={() => setZoom(false)}>
          <img src={active.img} alt={active.alt} className="er-lightbox__img" />
          <button className="er-lightbox__close" onClick={() => setZoom(false)}>✕</button>
        </div>
      )}

      {/* Modal */}
      <div className="er-modal" role="dialog" aria-modal="true">

        {/* ── Header ── */}
        <div className="er-header">
          <div className="er-header__brand">
            <div className="er-header__logo">T</div>
            <div>
              <div className="er-header__org">TECHNOLOGY MOVEMENT PAKISTAN</div>
              <div className="er-header__sub">Intra-Party Election · 19 January 2026</div>
            </div>
          </div>
          <button className="er-close" onClick={onClose} aria-label="Close">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M1 1l16 16M17 1L1 17" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        {/* ── Congrats banner ── */}
        <div className="er-congrats">
          <p className="er-congrats__text">
            Technology Movement Pakistan (TMP) congratulates all newly elected office bearers on
            their successful election. We wish them every success in serving the party and the
            nation.{" "}
            <strong>Official assumption of responsibilities: 22.06.2026.</strong>
          </p>
        </div>

        {/* ── Tabs ── */}
        <div className="er-tabs">
          {DOCS.map(d => (
            <button
              key={d.key}
              className={`er-tab ${tab === d.key ? "er-tab--active" : ""}`}
              onClick={() => { setTab(d.key); setZoom(false); }}
            >
              <span className="er-tab__icon">{d.icon}</span>
              {d.label}
            </button>
          ))}
        </div>

        {/* ── Document image ── */}
        <div className="er-body">
          <div className="er-img-panel">
            <div className="er-img-hint">
              <span>🔍</span> Tap image to enlarge
            </div>
            <div className="er-img-wrap" onClick={() => setZoom(true)}>
              <img
                src={active.img}
                alt={active.alt}
                className="er-doc-img"
              />
              <div className="er-img-overlay">
                <span className="er-img-zoom-icon">⛶</span>
              </div>
            </div>
          </div>
        </div>

        {/* ── Footer ── */}
        <div className="er-footer">
          <div className="er-footer__info">
            <span>📍 4th Floor, Karachi Electronic Market Sadar Karachi</span>
            <span>📞 0300-5084301 &nbsp;|&nbsp; 0323-5251143</span>
            <span>✉️ info@tmpak.pk</span>
          </div>
        </div>

      </div>
    </>
  );
}
